export default "__VITE_ASSET__e88d1f5d__"